module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-fototeca-selezione-territoriale",
      "title": "Selezione Territoriale"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d00f056!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/FototecaSelezioneTerritoriale.vue
// module id = 831
// module chunks = 39